module.exports = {
	"photoData": [
		{
			"isGrayscale": false,
			"colors": [
				"#76b4ec",
				"#2b3e59"
			],
			"title": "Sentinel.",
			"date": "2016-02-26T02:01:23.000Z",
			"tags": [
				"architecture",
				"dusk",
				"trees"
			],
			"slug": "sentinel",
			"location": {
				"coordinates": [
					37.779671666666665,
					-122.417375
				],
				"name": "Civic Center, San Francisco, California, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KSFO",
				"time": "2016-04-27T01:56:14.471Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 10,
					"gust": null,
					"direction": 290,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 900,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 3600,
						"cumulonimbus": false
					},
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 5500,
						"cumulonimbus": false
					}
				],
				"temperature": 16,
				"dewpoint": 12,
				"altimeter_in_hg": 30.15
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#ebd7c6",
				"#8a3b1c"
			],
			"title": "Lower Manhattan from Jersey shore.",
			"date": "2016-02-07T08:00:02.000Z",
			"tags": [
				"architecture",
				"lighthouse",
				"skyline"
			],
			"slug": "lower-manhattan-from-jersey-shore",
			"location": {
				"coordinates": [
					40.72766666666667,
					-74.03061166666667
				],
				"name": "Newport Harbor, Jersey City, New Jersey, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KNYC",
				"time": "2016-04-07T04:51:02.143Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 9,
					"gust": 17,
					"direction": 240,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 3,
				"dewpoint": -6,
				"altimeter_in_hg": 30.28
			},
			"dimensions": [
				2160,
				1440
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#ececec",
				"#0c0c0c"
			],
			"title": "En route.",
			"date": "2016-02-06T21:35:51.000Z",
			"tags": [
				"girl",
				"heels",
				"subway"
			],
			"slug": "en-route",
			"location": {
				"coordinates": [
					40.75463833333333,
					-73.98407
				],
				"name": "Pennsylvania Station, New York, New York, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KNYC",
				"time": "2016-04-06T18:51:51.870Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": "VRB",
					"variation": true,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 3,
				"dewpoint": -8,
				"altimeter_in_hg": 30.34
			},
			"dimensions": [
				1440,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#e9ab8d",
				"#72271c"
			],
			"title": "Sunset on the Quiet Green.",
			"date": "2016-02-06T01:05:40.000Z",
			"tags": [
				"dusk",
				"school campus",
				"snow"
			],
			"slug": "sunset-on-the-quiet-green",
			"location": {
				"coordinates": [
					41.82672166666667,
					-71.40463833333334
				],
				"name": "Quiet Green, Providence, Rhode Island, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KPVD",
				"time": "2016-04-05T21:51:28.371Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 6,
					"gust": null,
					"direction": 310,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 3100,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 4600,
						"cumulonimbus": false
					}
				],
				"temperature": -1,
				"dewpoint": -3,
				"altimeter_in_hg": 30.05
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#acacac",
				"#343434"
			],
			"title": "Good luck exploring the infinite abyss. II",
			"date": "2015-12-20T22:22:40.000Z",
			"tags": [
				"architecture",
				"concrete",
				"girl"
			],
			"slug": "good-luck-exploring-the-infinite-abyss-ii",
			"location": {
				"coordinates": [
					9.933521666666667,
					-84.07664666666666
				],
				"name": "Museos del Banco Central, San Jos�, Costa Rica"
			},
			"weather": {
				"type": "METAR",
				"station": "MROC",
				"time": "2016-04-20T20:00:58.705Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 14,
					"gust": 27,
					"direction": 70,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": [
					{
						"abbreviation": "-",
						"meaning": "light intensity"
					},
					{
						"abbreviation": "RA",
						"meaning": "rain"
					}
				],
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 3500,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 10000,
						"cumulonimbus": false
					}
				],
				"temperature": 24,
				"dewpoint": 16,
				"altimeter_in_hg": 29.95
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#c1a877",
				"#781d17"
			],
			"title": "Lost in translation.",
			"date": "2015-11-29T03:02:06.000Z",
			"tags": [
				"christmas",
				"culture",
				"shop"
			],
			"slug": "lost-in-translation",
			"location": {
				"coordinates": [
					31.227625,
					121.49056666666667
				],
				"name": "Yu Garden Bazaar, Shanghai, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZSSS",
				"time": "2016-04-28T11:00:01.018Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": 160,
					"variation": null,
					"unit": "MPS"
				},
				"cavok": true,
				"visibility": null,
				"weather": null,
				"clouds": null,
				"temperature": 12,
				"dewpoint": 4,
				"altimeter_hpa": 1028
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#a6b2e0",
				"#063065"
			],
			"title": "Lujiazui from the Bund.",
			"date": "2015-11-29T01:19:35.000Z",
			"tags": [
				"architecture",
				"river",
				"skyline"
			],
			"slug": "lujiazui-from-the-bund",
			"location": {
				"coordinates": [
					31.236776666666668,
					121.48700333333333
				],
				"name": "Lujiazui, Shanghai, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZSSS",
				"time": "2016-04-28T09:30:03.611Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 2,
					"gust": null,
					"direction": 170,
					"variation": null,
					"unit": "MPS"
				},
				"cavok": true,
				"visibility": null,
				"weather": null,
				"clouds": null,
				"temperature": 12,
				"dewpoint": 3,
				"altimeter_hpa": 1027
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#b4b4b4",
				"#3c3c3c"
			],
			"title": "Expanded horizons.",
			"date": "2015-11-21T20:59:41.000Z",
			"tags": [
				"airport",
				"architecture",
				"parametric design"
			],
			"slug": "expanded-horizons",
			"location": {
				"coordinates": [
					22.628895,
					113.80733333333333
				],
				"name": "Shenzhen Bao'an International Airport, Shenzhen, Guangdong, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZGSZ",
				"time": "2016-04-21T05:00:54.645Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": 60,
					"variation": {
						"min": 20,
						"max": 100
					},
					"unit": "MPS"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 3300,
						"cumulonimbus": false
					}
				],
				"temperature": 28,
				"dewpoint": 19,
				"altimeter_hpa": 1016
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#c0dae7",
				"#2a4066"
			],
			"title": "Skyline football.",
			"date": "2015-11-19T04:17:25.000Z",
			"tags": [
				"football",
				"park",
				"skyline"
			],
			"slug": "skyline-football",
			"location": {
				"coordinates": [
					22.282228333333332,
					114.19064166666666
				],
				"name": "Victoria Park, Hong Kong, Hong Kong Island, China"
			},
			"weather": {
				"type": "METAR",
				"station": "VHHH",
				"time": "2016-04-18T12:30:20.411Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 6,
					"gust": null,
					"direction": 70,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2500,
						"cumulonimbus": false
					}
				],
				"temperature": 27,
				"dewpoint": 21,
				"altimeter_hpa": 1016
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#aad2ec",
				"#1a464f"
			],
			"title": "Still, forward.",
			"date": "2015-11-19T01:53:15.000Z",
			"tags": [
				"architecture",
				"office worker",
				"old and new"
			],
			"slug": "still-forward",
			"location": {
				"coordinates": [
					22.28703666666667,
					114.21192833333333
				],
				"name": "Taikoo Place, Hong Kong, Hong Kong Island, China"
			},
			"weather": {
				"type": "METAR",
				"station": "VHHH",
				"time": "2016-04-18T10:00:24.849Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": 50,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2500,
						"cumulonimbus": false
					}
				],
				"temperature": 28,
				"dewpoint": 23,
				"altimeter_hpa": 1015
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#a6bed9",
				"#08447c"
			],
			"title": "Victoria Harbour at dawn.",
			"date": "2015-11-17T16:11:37.000Z",
			"tags": [
				"harbour",
				"skyline",
				"sunrise"
			],
			"slug": "victoria-harbour-at-dawn",
			"location": {
				"coordinates": [
					22.28138333333333,
					114.17364500000001
				],
				"name": "Renaissance Hong Kong Harbour View Hotel, Hong Kong, Hong Kong Island, China"
			},
			"weather": {
				"type": "METAR",
				"station": "VHHH",
				"time": "2016-04-17T00:00:43.543Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 12,
					"gust": null,
					"direction": 100,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 1200,
						"cumulonimbus": false
					}
				],
				"temperature": 26,
				"dewpoint": 23,
				"altimeter_hpa": 1014
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#bbbbbb",
				"#474747"
			],
			"title": "Night stroll.",
			"date": "2015-11-17T03:40:20.000Z",
			"tags": [
				"night",
				"pier",
				"shadow"
			],
			"slug": "night-stroll",
			"location": {
				"coordinates": [
					22.217499999999998,
					114.21000000000001
				],
				"name": "Blake Pier at Stanley, Hong Kong, Hong Kong Island, China"
			},
			"weather": {
				"type": "METAR",
				"station": "VHHH",
				"time": "2016-04-16T11:30:05.726Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 10,
					"gust": null,
					"direction": 120,
					"variation": {
						"min": 100,
						"max": 160
					},
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 1800,
						"cumulonimbus": false
					}
				],
				"temperature": 27,
				"dewpoint": 22,
				"altimeter_hpa": 1012
			},
			"dimensions": [
				863,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#fcf4f4",
				"#1c5a6b"
			],
			"title": "Seaside outing.",
			"date": "2015-11-16T02:19:23.000Z",
			"tags": [
				"family",
				"ocean",
				"rocks"
			],
			"slug": "seaside-outing",
			"location": {
				"coordinates": [
					22.27457,
					114.116655
				],
				"name": "Mt. Davis, Hong Kong, Hong Kong Island, China"
			},
			"weather": {
				"type": "METAR",
				"station": "VHHH",
				"time": "2016-04-15T10:30:13.257Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 19,
					"gust": null,
					"direction": 110,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 1500,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 2500,
						"cumulonimbus": false
					}
				],
				"temperature": 26,
				"dewpoint": 21,
				"altimeter_hpa": 1014
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#f7eacf",
				"#4f4722"
			],
			"title": "Eye of Providence.",
			"date": "2015-08-22T22:18:39.000Z",
			"tags": [
				"eye",
				"government",
				"interior design"
			],
			"slug": "eye-of-providence",
			"location": {
				"coordinates": [
					19.432503333333333,
					-99.13123333333333
				],
				"name": "National Palace, Mexico City, Mexico"
			},
			"weather": {
				"type": "METAR",
				"station": "MMMX",
				"time": "2016-04-22T20:45:55.683Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 12,
					"gust": null,
					"direction": 110,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 8,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 2500,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 10000,
						"cumulonimbus": false
					}
				],
				"temperature": 23,
				"dewpoint": 9,
				"altimeter_in_hg": 30.25
			},
			"dimensions": [
				2160,
				1440
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#d3d3d3",
				"#555555"
			],
			"title": "Triumph.",
			"date": "2015-08-22T06:11:23.000Z",
			"tags": [
				"arch",
				"architecture",
				"plaza"
			],
			"slug": "triumph",
			"location": {
				"coordinates": [
					19.436058333333335,
					-99.15382500000001
				],
				"name": "Monument to the Revolution, Mexico City, D.F., Mexico"
			},
			"weather": {
				"type": "METAR",
				"station": "MMMX",
				"time": "2016-04-22T03:47:41.422Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": 70,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 8,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 8000,
						"cumulonimbus": false
					}
				],
				"temperature": 16,
				"dewpoint": 12,
				"altimeter_in_hg": 30.36
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#d3bda0",
				"#27445e"
			],
			"title": "Frida's devices.",
			"date": "2015-08-21T21:24:19.000Z",
			"tags": [
				"art supplies",
				"artist",
				"museum"
			],
			"slug": "fridas-devices",
			"location": {
				"coordinates": [
					19.35529166666667,
					-99.16251166666667
				],
				"name": "Frida Kahlo Museum, Mexico City, Mexico"
			},
			"weather": {
				"type": "SPECI",
				"station": "MMMX",
				"time": "2016-04-21T19:43:57.835Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 8,
					"gust": null,
					"direction": 240,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 4,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 2000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 8000,
						"cumulonimbus": false
					}
				],
				"temperature": 21,
				"dewpoint": 7,
				"altimeter_in_hg": 30.29
			},
			"dimensions": [
				2160,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#c9a286",
				"#5b3606"
			],
			"title": "Browse.",
			"date": "2015-08-20T04:05:28.000Z",
			"tags": [
				"books",
				"bookstore",
				"girl"
			],
			"slug": "browse",
			"location": {
				"coordinates": [
					19.418245000000002,
					-99.15875333333334
				],
				"name": "Cafebrer�a El P�ndulo, Mexico City, Mexico"
			},
			"weather": {
				"type": "SPECI",
				"station": "MMMX",
				"time": "2016-04-20T02:18:51.140Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": 60,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 2000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 8000,
						"cumulonimbus": false
					}
				],
				"temperature": 18,
				"dewpoint": 12,
				"altimeter_in_hg": 30.32
			},
			"dimensions": [
				2160,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#e2d2a2",
				"#674a08"
			],
			"title": "Risen.",
			"date": "2015-08-18T23:03:14.000Z",
			"tags": [
				"interior design",
				"lighting",
				"space"
			],
			"slug": "risen",
			"location": {
				"coordinates": [
					19.425696666666667,
					-99.18176333333334
				],
				"name": "Museum of Modern Art, Mexico City, Mexico"
			},
			"weather": {
				"type": "METAR",
				"station": "MMMX",
				"time": "2016-04-18T20:44:10.379Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 9,
					"gust": null,
					"direction": 310,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 7,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 2000,
						"cumulonimbus": true
					},
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 8000,
						"cumulonimbus": false
					}
				],
				"temperature": 18,
				"dewpoint": 12,
				"altimeter_in_hg": 30.28
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#bebce0",
				"#213262"
			],
			"title": "Sharks.",
			"date": "2015-08-16T02:51:20.000Z",
			"tags": [
				"quadrangle",
				"school campus",
				"sculpture"
			],
			"slug": "sharks",
			"location": {
				"coordinates": [
					37.424366666666664,
					-122.16791333333333
				],
				"name": "Stanford Law School, Stanford, California, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KNUQ",
				"time": "2016-04-16T02:56:16.280Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 6,
					"gust": null,
					"direction": 350,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 3,
				"weather": [
					{
						"abbreviation": "HZ",
						"meaning": "haze"
					}
				],
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 24,
				"dewpoint": 16,
				"altimeter_in_hg": 29.89
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#f9f0e4",
				"#83512d"
			],
			"title": "Nexus.",
			"date": "2015-08-16T02:02:26.000Z",
			"tags": [
				"architecture",
				"campus",
				"dusk"
			],
			"slug": "nexus",
			"location": {
				"coordinates": [
					37.430924999999995,
					-122.17366166666667
				],
				"name": "James H. Clark Center, Stanford, California, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KNUQ",
				"time": "2016-04-16T01:56:05.254Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 11,
					"gust": null,
					"direction": 350,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 8,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 27,
				"dewpoint": 17,
				"altimeter_in_hg": 29.88
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#f1f1f1",
				"#383838"
			],
			"title": "Ascend.",
			"date": "2015-07-16T23:46:23.000Z",
			"tags": [
				"lighthouse",
				"stairs",
				"window"
			],
			"slug": "ascend",
			"location": {
				"coordinates": [
					29.885424999999998,
					-81.28853333333333
				],
				"name": "St. Augustine Lighthouse, St. Augustine, Florida, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KSGJ",
				"time": "2016-04-16T20:58:50.322Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 6,
					"gust": null,
					"direction": 240,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 7500,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 9000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 11000,
						"cumulonimbus": false
					}
				],
				"temperature": 31,
				"dewpoint": 23,
				"altimeter_in_hg": 29.95
			},
			"dimensions": [
				960,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#f0e2c5",
				"#274b63"
			],
			"title": "Refuel.",
			"date": "2015-07-15T22:48:53.000Z",
			"tags": [
				"coffee shop",
				"furniture",
				"interior design"
			],
			"slug": "refuel",
			"location": {
				"coordinates": [
					44.93540333333333,
					-93.63243333333332
				],
				"name": "Spring Park Coffee, Green Cove Springs, Florida, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "K42J",
				"time": "2016-04-15T19:55:09.353Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": 250,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 4900,
						"cumulonimbus": false
					},
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 10000,
						"cumulonimbus": false
					}
				],
				"temperature": 28,
				"dewpoint": 23,
				"altimeter_in_hg": 29.95
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#dfe6f0",
				"#4a3314"
			],
			"title": "Sanctuary.",
			"date": "2015-07-14T20:53:20.000Z",
			"tags": [
				"architecture",
				"meditation",
				"nature"
			],
			"slug": "sanctuary",
			"location": {
				"coordinates": [
					29.64200333333333,
					-82.363675
				],
				"name": "Baughman Center, Gainesville, Florida, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KGNV",
				"time": "2016-04-14T14:53:10.998Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 7,
					"gust": null,
					"direction": 260,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2300,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 2900,
						"cumulonimbus": false
					}
				],
				"temperature": 31,
				"dewpoint": 24,
				"altimeter_in_hg": 29.95
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#dde6f4",
				"#21335c"
			],
			"title": "Sink in.",
			"date": "2015-07-13T17:19:04.000Z",
			"tags": [
				"architecture",
				"school campus",
				"sculpture"
			],
			"slug": "sink-in",
			"location": {
				"coordinates": [
					29.64775,
					-82.34456333333333
				],
				"name": "Marston Science Library, Gainesville, Florida, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KGNV",
				"time": "2016-04-13T13:53:18.183Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 3,
					"gust": null,
					"direction": "VRB",
					"variation": true,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 27,
				"dewpoint": 24,
				"altimeter_in_hg": 29.98
			},
			"dimensions": [
				948,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#c1c6e6",
				"#5e3722"
			],
			"title": "Peak.",
			"date": "2015-07-04T20:14:00.000Z",
			"tags": [
				"canyon",
				"landscape",
				"mountain"
			],
			"slug": "peak",
			"location": {
				"coordinates": [
					37.261075,
					-112.95584666666667
				],
				"name": "Great White Throne, Hurricane, Utah, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KAZC",
				"time": "2016-04-04T20:15:06.668Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 8,
					"gust": 14,
					"direction": 250,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": [
					{
						"abbreviation": "VC",
						"meaning": "in the vicinity"
					},
					{
						"abbreviation": "TS",
						"meaning": "thunderstorm"
					}
				],
				"clouds": [
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 6000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 9000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 11000,
						"cumulonimbus": false
					}
				],
				"temperature": 29,
				"dewpoint": 11,
				"altimeter_in_hg": 30.11
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#cbdaed",
				"#525122"
			],
			"title": "Start of a revolution.",
			"date": "2015-04-14T17:40:51.000Z",
			"tags": [
				"architecture",
				"museum",
				"plaza"
			],
			"slug": "start-of-a-revolution",
			"location": {
				"coordinates": [
					30.54726666666667,
					114.29692
				],
				"name": "1911 Revolution Museum (from top of Yellow Crane Tower), Wuhan, Hubei, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZHHH",
				"time": "2016-04-14T03:00:23.581Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": 240,
					"variation": {
						"min": 220,
						"max": 280
					},
					"unit": "MPS"
				},
				"cavok": true,
				"visibility": null,
				"weather": null,
				"clouds": null,
				"temperature": 18,
				"dewpoint": 3,
				"altimeter_hpa": 1020
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#ecdbac",
				"#9c3618"
			],
			"title": "Enlightenment.",
			"date": "2015-04-13T19:46:30.000Z",
			"tags": [
				"buddha",
				"temple",
				"throne"
			],
			"slug": "enlightenment",
			"location": {
				"coordinates": [
					13.751238333333333,
					100.49283
				],
				"name": "Wat Phra Kaew (Temple of the Emerald Buddha), Bangkok, Thailand"
			},
			"weather": {
				"type": "METAR",
				"station": "VTBD",
				"time": "2016-04-13T06:00:53.036Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": 90,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 3000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 30000,
						"cumulonimbus": false
					}
				],
				"temperature": 33,
				"dewpoint": 21,
				"altimeter_hpa": 1014
			},
			"dimensions": [
				2511,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#e0e1df",
				"#5a4229"
			],
			"title": "Form.",
			"date": "2015-04-12T01:18:32.000Z",
			"tags": [
				"boxing ring",
				"muay thai",
				"stadium"
			],
			"slug": "form",
			"location": {
				"coordinates": [
					13.867245,
					100.60886333333333
				],
				"name": "Lumpinee Boxing Stadium, Bangkok, Thailand"
			},
			"weather": {
				"type": "METAR",
				"station": "VTBD",
				"time": "2016-04-11T11:00:56.448Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 9,
					"gust": null,
					"direction": 130,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "SCT",
						"meaning": "scattered",
						"altitude": 12000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 30000,
						"cumulonimbus": false
					}
				],
				"temperature": 30,
				"dewpoint": 22,
				"altimeter_hpa": 1009
			},
			"dimensions": [
				2160,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#d3dff3",
				"#08607d"
			],
			"title": "The rock.",
			"date": "2015-04-09T19:51:29.000Z",
			"tags": [
				"island",
				"ocean",
				"rocks"
			],
			"slug": "the-rock",
			"location": {
				"coordinates": [
					8.592595000000001,
					97.63977000000001
				],
				"name": "Mu Ko Similan National Park, Phang Nga, Thailand"
			},
			"weather": {
				"type": "METAR",
				"station": "VTSP",
				"time": "2016-04-09T06:00:34.702Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 8,
					"gust": null,
					"direction": 70,
					"variation": {
						"min": 20,
						"max": 130
					},
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2200,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 30000,
						"cumulonimbus": false
					}
				],
				"temperature": 34,
				"dewpoint": 16,
				"altimeter_hpa": 1011
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#ba8364",
				"#321d18"
			],
			"title": "Point.",
			"date": "2015-04-08T17:14:19.000Z",
			"tags": [
				"island",
				"lines",
				"rocks"
			],
			"slug": "point",
			"location": {
				"coordinates": [
					8.275421666666668,
					98.50051666666667
				],
				"name": "Khao Phing Kan (James Bond Island), Phang Nga, Thailand"
			},
			"weather": {
				"type": "METAR",
				"station": "VTSP",
				"time": "2016-04-08T03:30:07.549Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 8,
					"gust": null,
					"direction": 90,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 8000,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 30000,
						"cumulonimbus": false
					}
				],
				"temperature": 31,
				"dewpoint": 21,
				"altimeter_hpa": 1011
			},
			"dimensions": [
				799,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#b1aadf",
				"#1c421d"
			],
			"title": "Andaman shore.",
			"date": "2015-04-08T16:10:34.000Z",
			"tags": [
				"boating",
				"ocean",
				"trees"
			],
			"slug": "andaman-shore",
			"location": {
				"coordinates": [
					8.300508333333335,
					98.45563
				],
				"name": "Ao Phang Nga National Park, Phang Nga, Thailand"
			},
			"weather": {
				"type": "METAR",
				"station": "VTSP",
				"time": "2016-04-08T01:00:49.891Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 6,
					"gust": null,
					"direction": 100,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 8000,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 2000,
						"cumulonimbus": false
					},
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 30000,
						"cumulonimbus": false
					}
				],
				"temperature": 28,
				"dewpoint": 24,
				"altimeter_hpa": 1011
			},
			"dimensions": [
				2221,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#d0a684",
				"#571e20"
			],
			"title": "Shredding rainbow.",
			"date": "2015-01-17T19:51:00.000Z",
			"tags": [
				"backpack",
				"forest",
				"snowboarding"
			],
			"slug": "shredding-rainbow",
			"location": {
				"coordinates": [
					39.46415833333334,
					-106.055145
				],
				"name": "Breckenridge Ski Resort, Breckenridge, Colorado, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KCCU",
				"time": "2016-04-17T18:55:17.497Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 20,
					"gust": 27,
					"direction": 260,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": null,
				"weather": null,
				"clouds": null,
				"temperature": -6,
				"dewpoint": -19,
				"altimeter_in_hg": 30.34
			},
			"dimensions": [
				1080,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#cde1fb",
				"#122269"
			],
			"title": "Haleakalā.",
			"date": "2014-12-28T21:00:15.000Z",
			"tags": [
				"island",
				"mountain",
				"volcano"
			],
			"slug": "haleakala",
			"location": {
				"coordinates": [
					20.715094999999998,
					-156.24967166666664
				],
				"name": "Haleakal?, Kula, Hawaii, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "PHKO",
				"time": "2016-04-28T22:53:59.512Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 9,
					"gust": null,
					"direction": 330,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 5000,
						"cumulonimbus": false
					}
				],
				"temperature": 27,
				"dewpoint": 15,
				"altimeter_in_hg": 29.88
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#d5d5d5",
				"#4f4f4f"
			],
			"title": "Snapshot.",
			"date": "2014-09-06T23:58:41.000Z",
			"tags": [
				"architecture",
				"concrete",
				"street"
			],
			"slug": "snapshot",
			"location": {
				"coordinates": [
					31.254633333333334,
					121.49212833333334
				],
				"name": "1933??? (1933 Shanghai), Shanghai, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZSSS",
				"time": "2016-04-06T09:00:21.168Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": 60,
					"variation": {
						"min": 30,
						"max": 90
					},
					"unit": "MPS"
				},
				"cavok": true,
				"visibility": null,
				"weather": null,
				"clouds": null,
				"temperature": 29,
				"dewpoint": 21,
				"altimeter_hpa": 1009
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#be8771",
				"#1c130c"
			],
			"title": "The graduate.",
			"date": "2013-05-19T23:57:45.000Z",
			"tags": [
				"graduation",
				"school campus",
				"student"
			],
			"slug": "the-graduate",
			"location": {
				"coordinates": [
					37.873446666666666,
					-122.25401333333333
				],
				"name": "Greek Theatre, Berkeley, California, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KOAK",
				"time": "2016-04-19T23:53:32.516Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 10,
					"gust": null,
					"direction": 290,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 22,
				"dewpoint": 10,
				"altimeter_in_hg": 30.03
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#dcc6a5",
				"#664806"
			],
			"title": "The sun and the moon.",
			"date": "2012-12-18T23:22:51.000Z",
			"tags": [
				"architecture",
				"fall",
				"pagoda"
			],
			"slug": "the-sun-and-the-moon",
			"location": {
				"coordinates": [
					25.275683333333333,
					110.28951166666667
				],
				"name": "???? (Sun & Moon Twin Pagodas Cultural Park), Guilin, Guangxi, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZGKL",
				"time": "2016-04-18T07:00:36.669Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 7,
					"gust": null,
					"direction": 60,
					"variation": {
						"min": 30,
						"max": 90
					},
					"unit": "MPS"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 4600,
						"cumulonimbus": false
					}
				],
				"temperature": 10,
				"dewpoint": 4,
				"altimeter_hpa": 1028
			},
			"dimensions": [
				2052,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#4cbcd9",
				"#192c60"
			],
			"title": "Neon ballroom.",
			"date": "2012-12-12T20:05:23.000Z",
			"tags": [
				"airport",
				"lighting",
				"moving walkway"
			],
			"slug": "neon-ballroom",
			"location": {
				"coordinates": [
					41.97553666666667,
					-87.90321166666668
				],
				"name": "Chicago O'Hare International Airport, Chicago, Illinois, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KORD",
				"time": "2016-04-12T16:51:04.594Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 13,
					"gust": null,
					"direction": 210,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "FEW",
						"meaning": "few",
						"altitude": 25000,
						"cumulonimbus": false
					}
				],
				"temperature": 5,
				"dewpoint": -5,
				"altimeter_in_hg": 30.27
			},
			"dimensions": [
				2330,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#dd9d59",
				"#3d1f0f"
			],
			"title": "Through the gates of hell.",
			"date": "2012-11-19T04:16:16.000Z",
			"tags": [
				"gas flare",
				"night",
				"oil field"
			],
			"slug": "through-the-gates-of-hell",
			"location": {
				"coordinates": [
					48.210588333333334,
					-102.66410333333334
				],
				"name": "An oil field, Bakken formation, North Dakota, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "K08D",
				"time": "2016-04-19T02:15:40.551Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 8,
					"gust": null,
					"direction": 290,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 11000,
						"cumulonimbus": false
					}
				],
				"temperature": 3,
				"dewpoint": 2,
				"altimeter_in_hg": 29.85
			},
			"dimensions": [
				2560,
				1071
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#dad8d7",
				"#ab220a"
			],
			"title": "The warmth in my vein.",
			"date": "2012-10-08T02:16:34.000Z",
			"tags": [
				"architecture",
				"metropolitan",
				"skyline"
			],
			"slug": "the-warmth-in-my-vein",
			"location": {
				"coordinates": [
					44.95909666666667,
					-93.26956166666666
				],
				"name": "Minneapolis, Minnesota, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KMIC",
				"time": "2016-04-07T23:53:38.762Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 4,
					"gust": null,
					"direction": 160,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 9,
				"dewpoint": -9,
				"altimeter_in_hg": 29.92
			},
			"dimensions": [
				2560,
				1401
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#b0bfd4",
				"#484848"
			],
			"title": "Our omnipotent overlord.",
			"date": "2012-09-17T01:41:19.000Z",
			"tags": [
				"architecture",
				"concrete",
				"window"
			],
			"slug": "our-omnipotent-overlord",
			"location": {
				"coordinates": [
					44.9715,
					-93.215
				],
				"name": "University Park Plaza, Minneapolis, Minnesota, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KMIC",
				"time": "2016-04-16T23:53:06.333Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 5,
					"gust": null,
					"direction": 340,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "CLR",
						"meaning": "no clouds under 12,000 ft",
						"altitude": null,
						"cumulonimbus": false
					}
				],
				"temperature": 23,
				"dewpoint": 9,
				"altimeter_in_hg": 29.88
			},
			"dimensions": [
				1223,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#99b8d2",
				"#04171b"
			],
			"title": "Lake Yellowstone Hotel.",
			"date": "2012-08-10T21:12:20.000Z",
			"tags": [
				"hotel",
				"lake",
				"national park"
			],
			"slug": "lake-yellowstone-hotel",
			"location": {
				"coordinates": [
					44.56556666666666,
					-110.418525
				],
				"name": "Elephant Back Mountain, Yellowstone National Park, Wyoming, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KP60",
				"time": "2016-04-10T19:56:00.609Z",
				"auto": true,
				"correction": false,
				"wind": {
					"speed": 0,
					"gust": null,
					"direction": 0,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 19,
				"weather": null,
				"clouds": null
			},
			"dimensions": [
				890,
				1440
			]
		},
		{
			"isGrayscale": true,
			"colors": [
				"#f4f4f4",
				"#5c5c5c"
			],
			"title": "The fallen.",
			"date": "2012-06-15T17:36:27.000Z",
			"tags": [
				"architecture",
				"concrete",
				"monument",
				"scouting"
			],
			"slug": "the-fallen",
			"location": {
				"coordinates": [
					31.244333333333334,
					121.48683333333334
				],
				"name": "Monument to the People's Heroes, Shanghai, China"
			},
			"weather": {
				"type": "METAR",
				"station": "ZSSS",
				"time": "2016-04-15T02:30:29.858Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 4,
					"gust": null,
					"direction": 80,
					"variation": null,
					"unit": "MPS"
				},
				"cavok": false,
				"visibility": 9999,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "BKN",
						"meaning": "broken",
						"altitude": 1600,
						"cumulonimbus": false
					}
				],
				"temperature": 26,
				"dewpoint": 22,
				"altimeter_hpa": 1005
			},
			"dimensions": [
				1149,
				1440
			]
		},
		{
			"isGrayscale": false,
			"colors": [
				"#e7ad90",
				"#4b241e"
			],
			"title": "Joshua Ryan Miller.",
			"date": "2009-12-04T23:39:50.000Z",
			"tags": [
				"guitar",
				"musician",
				"recording studio"
			],
			"slug": "joshua-ryan-miller",
			"location": {
				"coordinates": [
					45.37788833333333,
					-94.01636666666667
				],
				"name": "Stirling Sound, Clearwater, Minnesota, United States"
			},
			"weather": {
				"type": "METAR",
				"station": "KSTC",
				"time": "2016-04-04T21:53:00.212Z",
				"auto": false,
				"correction": false,
				"wind": {
					"speed": 9,
					"gust": null,
					"direction": 220,
					"variation": null,
					"unit": "KT"
				},
				"cavok": false,
				"visibility": 10,
				"weather": null,
				"clouds": [
					{
						"abbreviation": "OVC",
						"meaning": "overcast",
						"altitude": 1700,
						"cumulonimbus": false
					}
				],
				"temperature": -7,
				"dewpoint": -12,
				"altimeter_in_hg": 29.94
			},
			"dimensions": [
				960,
				1440
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./app/data/data.json
// module id = 308
// module chunks = 1